import useCheckBrand from '@/hooks/use-check-brand';

const useActiveBrand = () => {
	const { isRangeRover, isDefender, isDiscovery } = useCheckBrand();

	if (isRangeRover) return 'range-rover';
	if (isDefender) return 'defender';
	if (isDiscovery) return 'discovery';
};

export default useActiveBrand;
